/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'ທຄ', 'ທ', 'ຕອນເຊົ້າ', 'ຕອນທ່ຽງ', 'ຕອນແລງ',
      'ກາງຄືນ'
    ],
    [
      'ທ່ຽງຄືນ', 'ຕອນທ່ຽງ', 'ຕອນເຊົ້າ',
      'ຕອນບ່າຍ', 'ຕອນແລງ', 'ກາງຄືນ'
    ],
    [
      'ທ່ຽງຄືນ', 'ຕອນທ່ຽງ', 'ຕອນເຊົ້າ',
      'ຕອນບ່າຍ', 'ຕອນແລງ', 'ຕອນກາງຄືນ'
    ]
  ],
  [
    ['ທຄ', 'ຕອນທ່ຽງ', 'ຊ', 'ສ', 'ລ', 'ກຄ'],
    [
      'ທ່ຽງ​ຄືນ', 'ທ່ຽງ', '​ເຊົ້າ', 'ສວຍ', 'ແລງ',
      '​ກາງ​ຄືນ'
    ],
    [
      'ທ່ຽງຄືນ', 'ຕອນທ່ຽງ', '​ເຊົ້າ', 'ສວຍ',
      'ແລງ', '​ກາງ​ຄືນ'
    ]
  ],
  [
    '00:00', '12:00', ['05:00', '12:00'], ['12:00', '16:00'], ['16:00', '20:00'],
    ['20:00', '05:00']
  ]
];
